import { AlertCircle } from '@/components/icons/barrel';
import useSymbol from '@/hooks/use-symbol';
import { useMarketStore } from '@/store/use-markets-store';
import { MarketStatus } from '@/types';
import { useStore } from 'zustand';

export default function ReduceOnlyBanner() {
  const symbol = useSymbol();
  const isReduceOnly = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.status === MarketStatus.REDUCE_ONLY,
  );

  if (!isReduceOnly) return null;

  return (
    <div className="flex items-center gap-3 border-b border-border bg-yellow px-6 py-3 text-black sm:px-8">
      <AlertCircle size={16} className="shrink-0" />
      <p className="text-sm">
        This market has been placed in reduce-only mode. Remaining open
        positions in this market will be closed on March 13th, 2026 at 4:00 PM
        ET. Please ensure any open positions are closed before then.{' '}
        <a
          href="https://docs.vestmarkets.com/exchange-notices#id-2-12-2026"
          target="_blank"
          rel="noopener noreferrer"
          className="font-medium underline hover:no-underline"
        >
          Learn more
        </a>
      </p>
    </div>
  );
}
